import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {PageResponse} from '@core/models/page-response';
import {PageableParams} from '@core/models/pageable-params';
import {NotificacaoVerificacao} from '@core/models/verificacao';

export interface OpcoesFiltroVerificacao {
  status: string[];
  fase: string[];
  superintendencia: string[];
  concessionaria: string[];
}

@Injectable({providedIn: 'root'})
export class VerificacaoService {
  private uri = environment.api.uri.concat('notificacao/verificacao');
  private http = inject(HttpClient);

  get(params: PageableParams): Observable<PageResponse<NotificacaoVerificacao>> {
    return this.http.get<PageResponse<NotificacaoVerificacao>>(`${this.uri}?${params.toQueryString()}`);
  }

  /** Valores disponíveis pra cada filtro (filtro em cascata), dados os outros filtros
   * já ativos — cada campo da resposta ignora o filtro do próprio campo. */
  getOpcoesFiltro(filters: Record<string, unknown>): Observable<OpcoesFiltroVerificacao> {
    const params = new PageableParams();
    params.filters = filters;
    return this.http.get<OpcoesFiltroVerificacao>(`${this.uri}/opcoes-filtro?${params.onlyFiltersToQueryString()}`);
  }
}
